// Turkey/Ankara-aware date helpers.
// All formatting outputs Europe/Istanbul TZ regardless of the browser's local TZ.

const TZ = "Europe/Istanbul";
const LOCALE = "tr-TR";

export const TR_TZ = TZ;

// Now in Europe/Istanbul as Date (still epoch-correct; only display differs)
export const nowTR = () => new Date();

// iter263 — Return "YYYY-MM-DD" for TODAY in Turkey (not UTC).
// Uses Swedish locale which conveniently outputs ISO-8601 form.
export const todayTR = () => new Date().toLocaleDateString("sv-SE", { timeZone: TZ });

// iter263 — Return "HH:mm" for current time in Turkey.
export const nowHM = () => new Date().toLocaleTimeString(LOCALE, { timeZone: TZ, hour: "2-digit", minute: "2-digit" });

// Format ISO/Date → "DD.MM.YYYY"
export const fmtDate = (v) => {
  if (!v) return "";
  const d = typeof v === "string" ? new Date(v) : v;
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString(LOCALE, { timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric" });
};

// Format ISO/Date → "DD.MM.YYYY HH:mm"
export const fmtDateTime = (v) => {
  if (!v) return "";
  const d = typeof v === "string" ? new Date(v) : v;
  if (isNaN(d.getTime())) return "";
  return d.toLocaleString(LOCALE, { timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

// Format ISO/Date → "HH:mm:ss"
export const fmtTime = (v) => {
  if (!v) return "";
  const d = typeof v === "string" ? new Date(v) : v;
  if (isNaN(d.getTime())) return "";
  return d.toLocaleTimeString(LOCALE, { timeZone: TZ, hour: "2-digit", minute: "2-digit", second: "2-digit" });
};

// Format ISO/Date → weekday "Pazartesi, 12 Şubat 2026"
export const fmtLongDate = (v) => {
  const d = v ? (typeof v === "string" ? new Date(v) : v) : new Date();
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString(LOCALE, { timeZone: TZ, weekday: "long", day: "numeric", month: "long", year: "numeric" });
};

// DD.MM.YYYY → YYYY-MM-DD (ISO date only). Returns "" if invalid.
export const parseTrDate = (s) => {
  if (!s) return "";
  const m = String(s).trim().match(/^(\d{1,2})[.\-\/](\d{1,2})[.\-\/](\d{4})$/);
  if (!m) return "";
  const dd = m[1].padStart(2, "0");
  const mm = m[2].padStart(2, "0");
  const yy = m[3];
  const d = new Date(`${yy}-${mm}-${dd}T00:00:00`);
  if (isNaN(d.getTime())) return "";
  return `${yy}-${mm}-${dd}`;
};

// YYYY-MM-DD → DD.MM.YYYY
export const isoToTr = (iso) => {
  if (!iso) return "";
  const s = String(iso).slice(0, 10);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return "";
  return `${m[3]}.${m[2]}.${m[1]}`;
};

// Auto-format text input for DD.MM.YYYY as user types.
// Given raw text, returns a cleaned "DD.MM.YYYY" partial string.
export const formatDateInput = (raw) => {
  const digits = String(raw || "").replace(/\D/g, "").slice(0, 8);
  let out = digits;
  if (digits.length > 4) out = `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`;
  else if (digits.length > 2) out = `${digits.slice(0, 2)}.${digits.slice(2)}`;
  return out;
};
